module.exports = __webpack_public_path__ + "media/18 Doctors’ Day.c937fcd6.mp3";